import type { Amount } from "@/shared/types/billing";

/** Credits arrive as decimal strings (or numbers from a fake); shown whole when whole. */
export const formatCredits = (value: Amount) =>
  Number(value).toLocaleString(undefined, { maximumFractionDigits: 2 });

export const shortDate = (iso: string) =>
  new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
